module.exports = __webpack_public_path__ + "static/img/8.9bc2572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8.jpg
// module id = 7joU
// module chunks = 0